<template>
  <div>
    <div
      class="gt"
      v-if="currentInlay.inlay"
      :style="{
        width: currentInlay.gtDim.width + 'px',
        height: currentInlay.gtDim.height + 'px',
      }"
    >
      <div
        class="inlay"
        :style="{
          top: currentInlay.inlay.style.top,
          width: currentInlay.inlay.style.width,
          left: currentInlay.inlay.style.left,
          height: currentInlay.inlay.style.height,
          'background-color': currentInlay.inlay.style['background-color'],
        }"
      ></div>
      <div
        class="inlay-button"
        v-for="(button, index) in currentInlay.inlay.btns"
        :key="index"
        :style="{
          top: button.style.top,
          width: button.style.width,
          left: button.style.left,
          height: button.style.height,
          'background-color': button.style['background-color'],
        }"
      >
        <div
          class="gt-btn-img"
          :style="{
            'background-image': button.style.image['background-image'],
            'background-position': button.style.image['background-position'],
            'background-size': button.style.image['background-size'],
            filter: button.style.image.filter,
          }"
        ></div>
        <p
          :style="{ color: button.content.style.color }"
          class="button-content"
        >
          {{ button.content.content }}
        </p>
      </div>
      <div v-if="inlay.showBargraph && inlay.bargraph.length > 0">
        <template v-for="(led, index) in inlay.bargraph">
          <div
            v-if="led.type === inlay.selectedBarGType"
            class="bar_g"
            :key="'bar_g_' + index"
            :style="{
              top: led.style.top,
              left: led.style.left,
              height: led.style.height,
              width: led.style.width,
              'background-color': led.style['background-color'],
            }"
          ></div>
        </template>
      </div>
      <div
        class="gt-top"
        :style="{
          width: currentInlay.gtDim.width - 4 + 'px',
          height: currentInlay.gtDim.topHeight + 'px',
          'background-image': currentInlay.name.includes('gt10d')
            ? imgURL()
            : '',
          'background-repeat': 'no-repeat',
          'background-position': 'center',
          'z-index': currentInlay.name.includes('gt10d') ? 12 : 10,
          'background-color': currentInlay.gtBackground,
        }"
      >
        <div v-if="currentInlay.name.includes('gt10d')">
          <div class="gt10d-button" style="top: 19mm; left: 18mm"></div>
          <div class="gt10d-button" style="top: 19mm; left: 48mm"></div>
          <div class="gt10d-button" style="top: 68mm; left: 18mm"></div>
          <div class="gt10d-button" style="top: 68mm; left: 48mm"></div>
        </div>
      </div>
      <div
        class="gt-right"
        :style="{
          height: currentInlay.gtDim.height - 4 + 'px',
          width: currentInlay.gtDim.rWidth + 'px',
          'background-color': currentInlay.gtBackground,
        }"
      ></div>
      <div
        class="gt-left"
        :style="{
          height: currentInlay.gtDim.height - 4 + 'px',
          width: currentInlay.gtDim.lWidth + 'px',
          'background-color': currentInlay.gtBackground,
        }"
      ></div>
      <div
        class="gt-bottom"
        :style="{
          width: currentInlay.gtDim.width - 4 + 'px',
          height: currentInlay.gtDim.botHeight + 'px',
          'background-co lor': currentInlay.gtBackground,
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();

    const currentInlay = computed(() => store.getters.currentInlay);
    function imgURL() {
      return "url(" + process.env.BASE_URL + "images/gt/GT10Dw_top.png)";
    }
    return {
      currentInlay,
      imgURL,
    };
  },
};
</script>

<style lang="scss" scoped>
.inlay-button {
  border: 1px solid lightgray;
  position: absolute;
}
.inlay-button p {
  margin-bottom: 1px;
}
.gt {
  position: relative;
}
.gt-container {
  position: relative;
  margin: auto;
  height: 100%;
  width: 100%;
}
.gt-btn-img {
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
}
.inlay {
  position: absolute;
  // border: 1px solid lightgray;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease-out;
}

.slide-enter-to {
  position: absolute;
  left: 0;
}

.slide-enter-from {
  position: absolute;
  left: -100%;
}

.slide-leave-to {
  position: absolute;
  right: -100%;
}

.slide-leave-from {
  position: absolute;
  left: 0;
}
.button-content {
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  display: grid;
  justify-content: center;
  align-items: end;
}
.gt-top,
.gt-bottom {
  position: absolute;
  left: 0;
  z-index: 10;
  background-color: #fff;
}
.gt-top {
  top: 0;
  border-top: 1px solid lightgray;
}
.gt-bottom {
  bottom: 0;
  border-bottom: 1px solid lightgray;
  border-left: 1px solid lightgray;
}
.gt-right,
.gt-left {
  position: absolute;
  z-index: 10;
  background-color: #fff;
  border-top: 1px solid lightgray;
}
.gt-right {
  right: 0;
  border-right: 1px solid lightgray;
}
.gt-left {
  left: 0;
  border-left: 1px solid lightgray;
}
</style>
